interface QuizQuestion {
  id: string;
  question: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
}

export const dataStructuresQuizQuestions: QuizQuestion[] = [
  {
    id: 'ds-1',
    question: 'Which data structure would be most efficient for implementing a "undo/redo" functionality in a text editor?',
    options: [
      'Array',
      'Stack',
      'Queue',
      'Hash Table'
    ],
    correctAnswer: 1,
    explanation: 'A Stack is ideal for undo/redo operations because it follows Last-In-First-Out (LIFO) principle. Each text change can be pushed onto an undo stack, and when undoing, the changes can be popped and pushed onto a redo stack.'
  },
  {
    id: 'ds-2',
    question: `What is the main difference between an Array and a Linked List?`,
    options: [
      'Arrays can store more elements than Linked Lists',
      'Linked Lists are always faster than Arrays',
      'Arrays have constant-time element access, while Linked Lists require linear traversal',
      'Linked Lists can only store numbers, while Arrays can store any data type'
    ],
    correctAnswer: 2,
    explanation: 'Arrays provide O(1) access to elements using indices because they store elements in contiguous memory locations. Linked Lists require O(n) traversal to access elements as they are connected through references/pointers.'
  },
  {
    id: 'ds-3',
    question: 'Which of the following data structures is best suited for implementing a spell checker?',
    options: [
      'Array',
      'Linked List',
      'Hash Table',
      'Stack'
    ],
    correctAnswer: 2,
    explanation: 'A Hash Table is ideal for spell checkers because it provides O(1) average time complexity for lookups. The dictionary words can be stored as keys in the hash table, allowing for very fast word validation.'
  },
  {
    id: 'ds-4',
    question: `What is the primary advantage of using a Binary Search Tree (BST) over a regular Binary Tree?`,
    options: [
      'BSTs can store more elements',
      'BSTs allow for efficient searching and sorting operations',
      'BSTs use less memory',
      'BSTs are always perfectly balanced'
    ],
    correctAnswer: 1,
    explanation: 'Binary Search Trees maintain a specific ordering: for each node, all left subtree elements are smaller and all right subtree elements are larger. This property enables efficient O(log n) searching, insertion, and deletion operations, as well as in-order traversal for sorted output.'
  },
  {
    id: 'ds-5',
    question: 'In a Min Heap data structure, which of the following is always true?',
    options: [
      'The root is the largest element',
      'The root is the smallest element',
      'All levels must be completely filled',
      'The left child is always smaller than the right child'
    ],
    correctAnswer: 1,
    explanation: 'In a Min Heap, the root node is always the smallest element in the heap. Each parent node is smaller than its children, ensuring that the minimum element can always be accessed in O(1) time at the root.'
  }
];
